import React from "react";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import portfolioData from "../../../../portfolio";
import "./Innerpage.css";

const Othercreation = ({ portfolioItem }) => {
  const navigate = useNavigate();

  const displayedItems = portfolioData
    .filter((item) => item.title !== portfolioItem?.title)
    .slice(0, 3);

  const handleNavigate = (title) => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    navigate("/Portfolio/InnerPortfolio", { state: { title } });
  };

  const portfolioNavigate = () => {
    navigate("/portfolio");
  };
  const truncateText = (text, limit = 70) =>
    text?.length > limit ? text.slice(0, limit) + "..." : text;
  return (
    <div className="other-creation-section second-portfolio-section">
      <Container>
        <h2>
          OTHER CREATION FROM <span>CODEFII</span>
        </h2>
        <div className="row our-portfolio-page-row" id="portfolio-container">
          {displayedItems.length === 0 ? (
            <div className="col-12">
              <h3 className="not-found-text">No Portfolio Found</h3>
            </div>
          ) : (
            displayedItems.map((item, index) => (
              <div
                key={index}
                className="col-xl-4 col-md-6 col-sm-12 our-portfolio-page-col-1"
                onClick={() => handleNavigate(item.title)}
                style={{ cursor: "pointer" }}
              >
                <div className="other-from-wo">
                  <div className="inner-page-card-wrapper position-relative">
                    <div className="img-card">
                      <img
                        src={item.imgSrc}
                        className="w-100"
                        alt={item.title}
                      />
                    </div>
                    <div className="img-card-absolute position-absolute">
                      <img src={item.logoSrc} alt={`${item.title} Logo`} />
                    </div>
                    <h3>{item.title}</h3>
                    <p>{item.category}</p>
                    <p className="web-app">{truncateText(item.description)}</p>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
        <div className="arrow-row">
          <p className="btn" onClick={() => portfolioNavigate()}>
            <span>View All</span>
            <svg
              width="18"
              height="14"
              viewBox="0 0 18 14"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M1.49867 7.83594L14.487 7.83594L10.0762 12.2468C9.99737 12.3238 9.93464 12.4158 9.89162 12.5172C9.8486 12.6187 9.82613 12.7277 9.82552 12.8379C9.82492 12.9482 9.84618 13.0574 9.88808 13.1593C9.92999 13.2613 9.9917 13.3539 10.0696 13.4318C10.1476 13.5098 10.2402 13.5715 10.3422 13.6133C10.4441 13.6552 10.5534 13.6765 10.6636 13.6759C10.7738 13.6752 10.8828 13.6527 10.9843 13.6097C11.0857 13.5667 11.1777 13.5039 11.2547 13.4251L17.088 7.59177C17.2443 7.4355 17.332 7.22358 17.332 7.0026C17.332 6.78163 17.2443 6.56971 17.088 6.41344L11.2547 0.580105C11.1774 0.502573 11.0855 0.441086 10.9844 0.399183C10.8833 0.35728 10.7748 0.335786 10.6653 0.335938C10.5005 0.335974 10.3395 0.384867 10.2025 0.476437C10.0654 0.568007 9.95866 0.698143 9.8956 0.850393C9.83254 1.00264 9.81604 1.17017 9.84818 1.3318C9.88032 1.49343 9.95966 1.6419 10.0762 1.75844L14.487 6.16927L1.49867 6.16927C1.27765 6.16927 1.06569 6.25707 0.909412 6.41335C0.753132 6.56963 0.665335 6.78159 0.665335 7.00261C0.665335 7.22362 0.753132 7.43558 0.909412 7.59186C1.06569 7.74814 1.27765 7.83594 1.49867 7.83594Z" />
            </svg>
          </p>
        </div>
      </Container>
    </div>
  );
};

export default Othercreation;
